import * as React from "react";
import { useContext, useEffect } from "react";
import { useState } from "react";
import {
  type IUserDTO,
  AssignmentDTO,
  ComponentType,
  GroopContextDTO,
} from "./client";

interface GroupState {
  group: GroopContextDTO;
  assignments: AssignmentDTO[];
  allTags: string[];
  users: IUserDTO[];
  flags: string[];
  user_id: string;
  owner: boolean;
  avatar: string;
  group_email: string;
  pictureImageBase: string;
  sfConnectionId?: string;
  enable_chat?: boolean;
}

export const GroupContext = React.createContext<GroupState | undefined>(
  undefined,
);

interface Props {
  groopId: string;
  user_id: string;
  children: React.ReactNode;
  pictureImageBase: string;
  enable_chat?: boolean;
}

export const GroupContextProvider = (props: Props): JSX.Element => {
  const { groopId, children, user_id, pictureImageBase, enable_chat } = {
    ...props,
  };
  const [context, setContext] = useState<GroupState>();
  useEffect(() => {
    const fetchGroup = async () => {
      const m = await import("./client");

      const groop_api = new m.GroopApiClient({});

      const users = await groop_api.getUsers(groopId);

      const group = await groop_api.basicInfo(groopId);

      const allAssignments = group.assignments ?? [];

      const allTags = [
        ...new Set(
          allAssignments
            .flatMap((a) => a.components)
            .filter((c) => c.type === ComponentType.MultipleChoice)
            .flatMap((c) => c.options?.split("|") ?? [])
            .filter((t) => t.length > 0),
        ),
      ].sort((a, b) =>
        a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()),
      );

      setContext({
        group: group,
        assignments: allAssignments,
        allTags,
        user_id,
        users,
        flags: group.groopItFlagChoices?.split("|") ?? [],
        owner: group.isOwner,
        avatar:
          users.find((u) => u.id === user_id)?.avatarUrl ??
          "/Content/Images/default_avatar.png",
        group_email: group.email ?? "",
        pictureImageBase,
        sfConnectionId: group.salesforceConnection?.id,
        enable_chat,
      });
    };

    fetchGroup();
  }, [groopId, pictureImageBase, user_id, enable_chat]);
  return context ? (
    <GroupContext.Provider value={context}>{children}</GroupContext.Provider>
  ) : (
    <></>
  );
};

export const useGroupContext = () => {
  const context = useContext(GroupContext);
  if (!context) {
    throw "useGroupContext() invoked without a parent provider";
  }
  return context;
};
